'use client'

import { useEffect } from 'react'
import { Button } from '@/components/ui/button'
import { AlertCircle } from 'lucide-react'

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    // Log error to error reporting service
    console.error('Global error:', error)
  }, [error])

  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-4">
      <AlertCircle className="h-24 w-24 text-destructive mb-6" />
      <h1 className="text-4xl font-bold mb-2">Oops!</h1>
      <p className="text-xl text-muted-foreground text-center mb-8 max-w-md">
        Something went wrong while processing your request.
      </p>
      <div className="flex gap-4">
        <Button onClick={reset} size="lg">
          Try Again
        </Button>
        <Button variant="outline" size="lg" onClick={() => window.location.href = '/'}>
          Go Home
        </Button>
      </div>
      {process.env.NODE_ENV === 'development' && (
        <pre className="mt-8 p-4 bg-muted rounded-lg text-sm max-w-2xl overflow-auto">
          {error.message}
          {error.stack}
        </pre>
      )}
    </div>
  )
}
